import { useState } from "react";
import { postData } from "../newApis/apiMethods";
import { message } from "antd";

const useInvestmentClosure = (apiEndpoint: string, onSuccessCallback: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const mutate = async (payload: {
    investment_id: number | null;
    close_date: string;
  }) => {
    setIsLoading(true);
    setError(null);
    setData(null);

    try {
      const response = await postData(apiEndpoint, payload);
      setData(response.message);
      setIsLoading(false);

      if (response.status || response.status_code === 200) {
        if (onSuccessCallback) {
          onSuccessCallback({ message: response.message });
        }
      } else {
        const errorMessage =
          response.data?.message ||
          `Request failed with status ${response.status}`;
        setError(errorMessage);
        message.error(errorMessage);
      }
      return { success: true, data: response };
    } catch (err) {
      const errorMessage =
        (err as any)?.response?.data?.message ||
        (err as any).message ||
        "Something went wrong";
      setError(errorMessage);
      setIsLoading(false);
      message.error(errorMessage);
      return { success: false, error: errorMessage };
    }
  };

  return { mutate, isLoading, error, data };
};

export default useInvestmentClosure;
